export default "__VITE_ASSET__BSwwDaPp__"